export default __webpack_public_path__ + "media/images/add_16-fc2f136e5b66c1f3a4107ce2200f1ab5.png";